<template>
    <div class="mt-2">
        <Select2 class="form-control" v-model="myValue" :options="myOptions"
        :settings="{ placeholder:'Write/select itemgroups',width:'100%', }"
        @select="mySelectEvent($event)"/>

        <div class="row mt-3">
            <div class="col-md-12 col-12 ">
                <ul class="flex-container list-unstyled">
                    <li class="p-2 m-1 container-bg" v-for="value in $store.state.selectedItemGroups" v-bind:key="value.id">{{ value.text }}<i
                    class="fa fa-close" style="cursor: pointer" v-on:click="deleteSelection(value.id)"></i></li>
                </ul>
            </div>
        </div>

    </div>


</template>

<script>
    export default {
        name: "selectItemgroups", 
        data() {
            return {
                myValue: '',
                myOptions: [],
                itemgroups:[]
            }
        },
        methods: {
            mySelectEvent() {
                var newOptions = [];
                this.myOptions.forEach((item) => {
                    var disabled = item.disabled;
                    var id = item.id;
                    var text = item.text;
                    if (item.id == this.myValue) {
                        disabled = true;
                    }
                    var obj = {
                        id,
                        text,
                        disabled
                    }
                    //selectedValue
                    if (item.id == this.myValue) { 
                        this.$store.state.selectedItemgroups.push(obj);
                    }
                    newOptions.push(obj)
                });
                this.myOptions = newOptions;
                this.myValue = '';
            },
            deleteSelection(value){
                var newOptions = [];
                this.myOptions.forEach((item) => {
                    var disabled = item.disabled;
                    var id = item.id;
                    var text = item.text;
                    if (item.id == value) {
                        disabled = false;
                    }
                    var obj = {
                        id,
                        text,
                        disabled
                    }

                    newOptions.push(obj)
                    //selectedValue
                    this.$store.state.selectedItemgroups.forEach((item,index)=>{
                        if (item.id == value) {
                            this.$store.state.selectedItemgroups.splice(index,1);

                        }
                    });

                });
                this.myOptions = newOptions;

            }
        },
       created(){
            this.$store.dispatch('get','api/v1/itemgroups').then((data)=>{ 
                var newOptions = [];
                data.data.data.forEach((item)=>{
                    var disabled = item.disabled;
                    var id = item.id;
                    var text = item.title;
                    var obj = {
                        id,
                        text,
                        disabled
                    }
                    newOptions.push(obj)
                });
                this.itemgroups = [...data.data.data]
                this.myOptions=newOptions; 
            })
       } 
    }
</script>

<style scoped>
    .form-control, .input-group-text { 
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 4px;
        opacity: 1;
        border: 1px #ced4da;;
    }
    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;

        opacity: 1;
    }

</style>
